module.exports = __webpack_public_path__ + "static/media/promotional_7.a524042c.png";